export default "__VITE_ASSET__B7R8vgK$__"